export default {"src":"/_next/static/media/checkcircle.ba749d45.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};